import 'twin.macro';
import ImageURL from '@leuven2030/framework/Image/ImageURL';
import {
  StyleContent,
  StyleParallaxCover
} from '@leuven2030/framework/styles/general';
import { Parallax } from 'react-parallax';
import React, { FC } from 'react';
import get from 'lodash/get';
import tw from 'twin.macro';
type Props = {
  image: string | { url: string };
  title?: string;
  height?: number;
  imgixParams?: any;
  resetContentStyle?: boolean;
};

const ContentCover: FC<Props> = ({
  image,
  title = '',
  children,
  height = 300,
  resetContentStyle,
  imgixParams,
  ...props
}) => {
  const strength = 400;
  const bgImage = image
    ? ImageURL(get(image, 'url') || image, {
        fit: 'crop',
        w: 1500,
        h: 800,
        crop: 'entropy',
        blend: '8c777777',
        'blend-mode': 'normal',
        ...imgixParams
      })
    : null;
  return (
    <Parallax
      strength={strength}
      tw="bg-gray-600 border-b"
      className="dark"
      bgImage={bgImage}
      css={StyleParallaxCover}
    >
      <div
        tw="inset-0 z-10 flex items-stretch box-border"
        css={[
          !resetContentStyle && [StyleContent, tw` px-6 py-12`],
          {
            minHeight: height
          }
        ]}
      >
        <div tw="relative flex-1" {...props}>
          {title && <ContentCoverTitle title={title} />}
          {children}
        </div>
      </div>
    </Parallax>
  );
};

export const ContentCoverTitle = ({ title }) => (
  <h1 tw="text-white font-black text-3xl sm:text-4xl">{title}</h1>
);

export const ContentCoverCentered = (props) => (
  <div
    tw="mx-auto px-3 py-12 text-center text-white flex flex-col items-center space-y-6 z-10 relative"
    {...props}
  />
);

export default ContentCover;
